// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__2XbtX","iconButton-primary":"IconButton_iconButton-primary__3y4-j","iconButton-secondary":"IconButton_iconButton-secondary__2EUSR"};